import React from "react";
import { SideNav, Nav as BaseNav } from "react-sidenav";
import styled from "styled-components";
import {
  AppContainer as BaseAppContainer,
  ExampleNavigation as BaseNavigation,
  ExampleBody as Body
} from "./containers";
import { Icon as BaseIcon } from "react-icons-kit";
import { dashboard } from "react-icons-kit/fa/dashboard";
import { user } from "react-icons-kit/fa/user";
// import { shoppingCart } from "react-icons-kit/fa/shoppingCart";
// import { cubes } from "react-icons-kit/fa/cubes";
// import { circleO } from "react-icons-kit/fa/circleO";

import Header from "./Header";
import Namecard from "./Namecard";
import Namecard2 from "./Namecard2";
// import logo from "./logo.svg";
// import "./Navbar.css";

import {
  Widget,
  addResponseMessage,
  addLinkSnippet,
  addUserMessage
} from "react-chat-widget";
import "react-chat-widget/lib/styles.css";

const bellaLogo =
  "https://estacionpacifico.com/wp-content/uploads/2018/05/2015-10-06-FB-person.png";

const AppContainer = styled(BaseAppContainer)`
  // height: calc(100vh - 40px);
  // width: 100%;
  // height: 100%;
  // margin-left: 10%;
  // margin-right: 10%;
  flex-wrap: center;
`;

const Navigation = styled(BaseNavigation)`
  background: #303641;
  color: #8d97ad;
  font-size: 1em;
  letter-spacing: 2px;
  width: 150px;
  line-height: 22px;
`;

const IconCnt = styled.div`
  color: #fff;
  display: flex;
  justify-content: center;
  aligh-items: center;
  margin-bottom: 15px;
`;

const Nav = styled(BaseNav)`
  flex-direction: column;
  width: 125px;
  height: 125px;
  // border: 1px solid yellow;
  padding-top: 20px;
`;

const theme = {
  selectionColor: "#FFF",
  hoverBgColor: "#181b20",
  selectionBgColor: "#00BCD4"
};

const Text = styled.div`
  font-size: 0.9em;
  // text-transform: uppercase;
`;

const Col = styled.div`
  width: 50%;
  height: 100%;
  float: left;
`;

const Icon = props => <BaseIcon size={32} icon={props.icon} />;

export class Navbar extends React.Component {
  state = { selectedPath: "2" };

  componentDidMount() {
    addResponseMessage("Hey Ed! How are you? Let's practice our French!");
  }

  onItemSelection = arg => {
    this.setState({ selectedPath: arg.path });
  };

  handleNewUserMessage = newMessage => {
    console.log(`New message incoming! ${newMessage}`);
    // Now send the message throught the backend API
    // addResponseMessage(response);
  };

  render() {
    return (
      <AppContainer>
        <Navigation>
          <SideNav
            defaultSelectedPath="2"
            theme={theme}
            onItemSelection={this.onItemSelection}
          >
            <Nav id="1">
              <IconCnt>
                <Icon icon={user} />
              </IconCnt>
              <Text>Me</Text>
              <Text>9740283933</Text>
            </Nav>
            <Nav id="2">
              <IconCnt>
                <Icon icon={user} />
              </IconCnt>
              <Text>Bella Bates</Text>
              <Text>2352338493</Text>
            </Nav>
            <Nav id="3">
              <IconCnt>
                <Icon icon={user} />
              </IconCnt>
              <Text>Barrack Obama</Text>
              <Text>8263928161</Text>
            </Nav>
            <Nav id="4">
              <IconCnt>
                <Icon icon={user} />
              </IconCnt>
              <Text>Jim Jerry</Text>
              <Text>9172839222</Text>
            </Nav>
          </SideNav>
        </Navigation>
        <Body>
          <Header />

          <Namecard />
          <Namecard2 />
        </Body>
        <Widget
          handleNewUserMessage={this.handleNewUserMessage}
          profileAvatar={bellaLogo}
          title="Bella Bates"
          subtitle="You two are learning French"
        />
      </AppContainer>
    );
  }
}

export default Navbar;
